import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

export const itemColdefs = [
    {
        field: "id",
        headerName: "ID",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "itemDetails",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "disAssembleQty",
        headerName: "DisAssemble qty",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "rejection",
        headerName: "Rejection",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "storeTransfer",
        headerName: "Store transfer",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "rework",
        headerName: "Rework",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "reworkComplete",
        headerName: "Rework complete",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "completeDate",
        headerName: "Complete date",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "rejectedPartChange",
        headerName: "Rejected part change",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "changeDate",
        headerName: "Change date",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },

];


export const EmployeeProblemPopup = (props) => {
    return (
        <ModalBasic
            id="employee-problem"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Employee problem</span>
                <div className='item-grp grid grid-cols-2 gap-2.5 mt-3 items-start'>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.employeeObject.date}
                            handleChange={(event) => props.handleChange(event, 'date')}
                            className={props.validState?.error?.date !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Employee</label>
                        <MultiSelectDropdown
                            drpIdentity="Select d-assemble"
                            options={props.employeeObject.employeeList}
                            value={props.employeeObject.idEmployee > 0 ? props.employeeObject.employeeList.find(x => x.value === props.employeeObject.idEmployee) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idEmployee")
                            }
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Prblem description</label>
                        <textarea rows={8}
                            id='problemDesc' name='problemDesc'
                            value={props.employeeObject.problemDesc}
                            onChange={(event) => props.handleChange(event, 'problemDesc')}
                            className="h-full"
                        />
                    </div>
                    <div className='input-grp relative'>
                        {/* <label>
                            
                        </label> */}
                        <form className="input-grp w-full">
                            <label
                                htmlFor="Select_attachment"
                            // className="text-uplod block text-sm text-[#757575]"
                            >
                                Select attachment
                            </label>
                            <input
                                className="!pr-[35px]"
                                id="Select_attachment"
                                type="file"
                                onChange={(event) => props.onFileChange(event, 'EmployeeProblemAttachment')}
                            />
                        </form>
                        {props.employeeObject.attachment ?
                            <button
                                className="w-[20px] h-[20px] flex absolute bottom-[15%] right-[3%]"
                                onClick={() =>
                                    props.getFiles(
                                        "EmployeeProblemAttachment",
                                        props.employeeObject.attachment
                                    )
                                }
                            >
                                <FontAwesomeIcon icon={faEye} className="text-[#e78e3c] " title="View file" />
                                {/* <span className="text-xl text-[#e78e3c]">
                                                            View Files
                                                        </span> */}
                            </button>
                            :
                            null
                        }
                    </div>
                </div>

                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}